export default "__VITE_ASSET__By6vZ3_Z__"